(function() {
	"use strict"

	angular.module("ATMGurus")

		/**
		 * 	ATMG Main Controller
		 *
		 * 	application-wide stuff here
		 */
		.controller( "MainController", [
			"ApiCustomer",
			"Auth",
			"User",
			"$scope",
			"AddressBook",
			'Navigation',
			'Loader',
			"$http",
			"FilterService",
			"ATMGConf",
			"ErrorService",
			"$rootScope",
			"$timeout",
			"$socket",
			"$state",
			"FormService",
			"OracleStatusMonitorService",
			"Checkout",
			function( Customer, Auth, User, $scope, AddressBook, Navigation, Loader, $http, FilterService, Conf, ErrorService, $rootScope, $timeout, $socket, $state, FormService, OracleStatus, Checkout)  {

				var self = this;

				// link services to the Contoller
				this.User 			= User.getUserData();
				this.Cart 			= User.Cart;
				this.Checkout 		= Checkout;
				this.AddressBook 	= AddressBook;
				this.FilterService 	= FilterService;
				this.templates 		= Conf.templates;
				this.UserService	= User;
				this.Error 			= ErrorService;
				this.Customer 		= Customer;
				this.Navigation 	= Navigation;
				this.Loader			= Loader;

				// this.year 			= new Date().getFullYear();
				this.title 			= "ATM Parts | ATM Machines | ATM Training | ATM Repair | Triton | Hantle | Nautilus | Diebold | NCR | Tidel ";
				this.meta 			= { description: "ATM Parts multi brands, ATM Parts for Triton, Nautilus and Tranax ATMs. ATM parts, ATM repair, ATM training and refurbished ATM machines." };
				this.oracleDown		= false; // need it to keep track of that specific modal and anvoid closing every one

				this.status = "loading";

				this.loadingStack = 0;

				this.isLogged = function() {
					return $rootScope.isLogged;
				}

				/**----------------------------------------------------------------------------------------------------------
				*
				*		PhantomJS
				*	to ensure page contet has been loaded we provide a
				*	ng-status = [ 'loading' | 'ready' ]
				*	PhantomJS reads the status from there @ 100ms intervals and stores the page on
				*	ng-status === 'ready'
				*
				----------------------------------------------------------------------------------------------------------*/
				// @TODO take a look at me!
				self.checkStatus = function() {
					$timeout( function() {
						if ( $http.pendingRequests.length === 0 && self.loadingStack === 0) {
							$timeout( function() {
								if ( $http.pendingRequests.length === 0 ) {
									self.status = "ready";
								 }
							}, 1500 )
						}
						else  if ( self.status === "loading" ) {
							$timeout( function() {
								self.checkStatus()
							}, 1000)
						}
					}, 500 )
				};

				$scope.$on("$viewContentLoaded", function( event ) {
					self.checkStatus();
					event.preventDefault()
				} )

				/**
				*
				*
				*
				*/
				this.getUserFullName = function() {
					return User.getFullName()
				}

				this.modal = function(params) {
					params.visible = true
					$rootScope.$broadcast('modal.open', params)
				}

				this.closeModal = function() {
					$rootScope.$broadcast('modal.close')
				}

				// specific logout stuff
				this.logout = function() {
					Auth.logout()
				}

				/*-----------------------------------------------------
				*
				*	Filters and Pagination of AdddressBook
				*
				--------------------------------------------------------*/
				this.filters = FilterService.get( "addresses" )
				FilterService.get("contacts").take = 9999;

				// FilterService.fuzzySearch();

				this.turnPage = function( amount ) {
					if ( ( ( this.filters.page + amount ) > 0 )   ||  ( this.filters.page + amount ) <= AddressBook.pagination.total ) {
						AddressBook.pagination.current_page += amount;
						this.filters.page += amount;
					}
				}

				$scope.$watchGroup( ["MainCtrl.filters.page", "MainCtrl.filters.take"], function( nv, ov ) {
					if (nv !== ov) {
						self.fetchAddresses();
					}
				}, true)

				/*-----------------------------------------------------
				*
				*	Fetch Addresses
				*
				--------------------------------------------------------*/
				this.fetchAddresses = function() {
					AddressBook.fetchShippingAddresses(self.filters)
						.then(function(addresses) {
 							if (addresses) {
								$scope.MainCtrl.AddressBook.shippingAddresses = AddressBook.shippingAddresses;
							}
						}, function(reason) {
							// self.apiError(reason, 'shippingAddresses');
						});
				}

				/*-----------------------------------------------------
				 *
				 *	Title/Meta changes events
				 *
				 *
				--------------------------------------------------------*/
				$rootScope.$on( "meta.refreshed", function(e, data) {
					// self.title = data.page_title,
					self.title = 'ATMGurus'
					self.meta.description = 'ATMGurus, a store to buy ATM parts, repairs, and training!';
					self.meta.keywords = 'atmgurus, atm, atms, parts, repair, training, service, machine, machines, paper, roll, buy, new, sale, supplies, cash, dispenser, keypad, card, reader, emv, kit, upgrade, pci, compliance, accessibility, refurbished, certified, pre-owned, real-time, warehouse, inventory, management, topper, sign';
					// self.meta.description = data.description;
				})
			}
		])
})()


// WEBPACK FOOTER //
// ./src/app/controllers/MainController.js